import React from 'react'

const QualityAssurance = () => {
    return (
        <div>
            <h1>Quality Assurance</h1>
        </div>
    )
}

export default QualityAssurance